// app/components/ScrollRestoreOff.tsx
'use client';

import { useEffect } from 'react';

export default function ScrollRestoreOff() {
  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // reset to top on mount
    window.scrollTo(0, 0);
  }, []);

  return null;
}
